import * as React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { listenUser } from 'services/user'
import * as UserActions from 'store/user/actions'
import { IUserListenerContext, UserListenerContext } from './context'

export const withUserListener = (WrappedComponent: React.ElementType) => {
  interface IReduxStateProps {
    userId: string
  }

  interface IReduxDispatchProps {
    UserLib: any
  }

  interface IProps extends IReduxStateProps, IReduxDispatchProps {}

  const HOC: React.FC<IProps> = ({ userId, UserLib }, ...restProps) => {
    const { userListener, setUserListener } = React.useContext<
      IUserListenerContext
    >(UserListenerContext)

    React.useEffect(() => {
      if (userId) {
        const refOffListener = listenUser(
          userId,
          userData =>
            UserLib.updateUser(
              userData,
              () =>
                !userListener &&
                refOffListener &&
                setUserListener(() => refOffListener)
            ),
          err => console.log(err)
        )
      } else {
        setUserListener(null)
      }

      return () => userListener?.()
    }, [userId])

    return <WrappedComponent {...restProps} />
  }

  const mapStateToProps = ({ user, ..._rest }) => ({
    userId: user.auth?.uid
  })

  const mapDispatchToProps = (dispatch: Dispatch) => ({
    UserLib: bindActionCreators<any, any>(UserActions, dispatch)
  })

  const Connected = connect(mapStateToProps, mapDispatchToProps)(HOC)
  return props => <Connected {...props} />
}



// WEBPACK FOOTER //
// ./src/components/UserListener/withUserListener.tsx